module.exports = __webpack_public_path__ + "img/7878fa03f2183339f02595db4e116e52.png";